import { types as t, flow } from 'mobx-state-tree';

import { withEnv } from 'models/withEnv';

export const RelesysSettings = t
  .model('RelesysSettings', {
    clientId: '',
    clientSecret: '',
    hasClientSecret: false,
    smsText: '',
  })
  .views(withEnv)
  .actions((self) => ({
    afterCreate() {
      self.getSettings();
    },
    setClientId(clientId) {
      self.clientId = clientId;
    },
    setClientSecret(clientSecret) {
      self.clientSecret = clientSecret;
    },
    setSmsText(smsText) {
      self.smsText = smsText;
    },
    getSettings: flow(function* () {
      const res = yield self.env.api.integrations.relesysSettings();
      if (!res.error) {
        self.clientId = res.data.clientId;
        self.clientSecret = res.data.hasClientSecret ? '**********' : '';
        self.hasClientSecret = res.data.hasClientSecret;
        self.smsText = res.data.smsText;
      }
    }),
    submitSettings: flow(function* () {
      let data = { clientId: self.clientId, smsText: self.smsText };
      if (self.clientSecret && self.clientSecret !== '**********') {
        data.clientSecret = self.clientSecret;
      }
      const res = yield self.env.api.integrations.relesysSubmitSettings(data);
      if (res.status === 200) {
        self.hasClientSecret = true;
        self.env.showSuccess(self.env.t('integrations.relesys.settings.save.success'));
      } else {
        self.env.showError(self.env.t('integrations.relesys.settings.save.error'));
      }
      return res;
    }),
  }));
